/**
 * Guilds (ADR 0036), as pure rules: the cost, the size, who may do what to
 * whom, and who leads when the leader leaves. The server keeps the guilds
 * (`GuildService`, `GuildRegistry`); nothing here holds any.
 */
/** Gold burnt to found a guild (ADR 0038). */
export const GUILD_CREATE_COST = 500;
export const GUILD_MAX_MEMBERS = 50;
/** An invitation not answered in this time lapses. */
export const GUILD_INVITE_TTL_MS = 60_000;
export const GUILD_RANKS = ['leader', 'officer', 'member'];
const RANK_ORDER = { leader: 2, officer: 1, member: 0 };
export function outranks(actor, target) {
    return RANK_ORDER[actor] > RANK_ORDER[target];
}
/** Leader and officers invite. */
export function canInvite(rank) {
    return rank !== 'member';
}
/** One sends away only a lower rank; a member sends nobody away. */
export function canKick(actor, target) {
    return canInvite(actor) && outranks(actor, target);
}
/** Only the leader changes ranks, and only between officer and member. */
export function canSetRank(actor, rank) {
    return actor === 'leader' && rank !== 'leader';
}
export function canSetMotd(rank) {
    return rank !== 'member';
}
export function canDisband(rank) {
    return rank === 'leader';
}
/**
 * Who leads once `leavingId` is gone: the longest-standing officer, else the
 * longest-standing member; null when nobody is left.
 */
export function nextLeader(members, leavingId) {
    const rest = members.filter((member) => member.id !== leavingId);
    const byRank = (rank) => rest
        .filter((member) => member.rank === rank)
        .sort((a, b) => a.joinedAt - b.joinedAt || a.id.localeCompare(b.id))[0];
    return (byRank('officer') ?? byRank('member') ?? byRank('leader'))?.id ?? null;
}
/** Members as the window lists them: leader, officers, members; online first within a rank, then by name. */
export function compareMembers(a, b) {
    return (RANK_ORDER[b.rank] - RANK_ORDER[a.rank] ||
        Number(b.online) - Number(a.online) ||
        a.name.localeCompare(b.name));
}
//# sourceMappingURL=guild.js.map